<template>
  <tr class="my-list-row selectable">
    <td>
      <span class="text-bigger mr-2">{{ object.total_incl_tax }}€ TTC pour {{ $filters.fullname(object.contact) }}</span>
      <span class="text-smaller">{{ $filters.dateStringToHumanizedDate(object.created_at) }}</span>
    </td>
  </tr>
</template>

<script>

export default {
  name: "QuoteResultRow",
  props: {
    object: {
      type: Object,
      required: true,
    },
  },
};
</script>
